import React from "react";
import { useLocation } from "react-router-dom";

const Test = () => {
  const { state } = useLocation();
  console.log(state);
  return (
    <>
      <div>
        <h1>{state.SellPrice}</h1>
      </div>
    </>
  );
};

export default Test;
